export const sidebar = [
  {
    icon: "mdi-monitor",
    name: "Dashboard",
    to: "/dashboard",
    color: "#000000"
  }
];
export const sidebar2 = [];
export const mainMenu = [
  {
    icon: "mdi-home",
    name: "Dashboard",
    to: "/dashboard",
    color: "rgba(0, 0, 0, 0.5);"
  },
  {
    icon: "mdi-account",
    name: "Profil",
    to: "/profile",
    color: "rgba(0, 0, 0, 0.5);"
  },
  {
    icon: "mdi-key",
    name: "Ubah Kata Sandi",
    to: "/password",
    color: "rgba(0, 0, 0, 0.5);"
  }
  // {
  //   icon: "mdi-information-outline",
  //   name: "Tentang",
  //   to: "/tentang",
  //   color: "rgba(0, 0, 0, 0.5);"
  // }
];
